export default "__VITE_ASSET__4ccf8a23__"